import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataAnalyticsEvent, DataAnalyticsInitialData } from '../data-analytics/data-analytics.domain';
import type { LinkParameters } from '../link-registry.service';

export type RawParams = Record<string, unknown>;

export interface StateDeclaration {
  name?: string;
  parent: string;
  params: Array<string>;
  url: string;
}

export interface StateObject {
  abstract: boolean;
  data: unknown;
  name: string;
}

export interface TransitionOptions {
  custom?: object;
}

@Injectable({
  providedIn: 'root'
})
export abstract class RouterBaseService {

  abstract getStateUrl(stateName: string, params: RawParams): string;

  abstract getCurrentStateName(): string;

  abstract getCurrentStateParams(): LinkParameters;

  abstract getGlobalsCurrent(): StateDeclaration;

  abstract getStateRegistry(value: string): StateDeclaration;

  abstract getStateHref(name: unknown): string;

  abstract getStateParams(decode?: boolean): RawParams;

  abstract go(to: unknown, params?: RawParams, options?: unknown): Promise<unknown>;

  abstract includes(stateOrName: unknown, params?: RawParams, options?: unknown): boolean;

  abstract getParamsValue(key: string): unknown;

  abstract getRouteData(): unknown;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  abstract transitionOnStart?(fun: (() => void)): Function;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  abstract transitionOnSuccess(criteria: unknown, fun: ((options: TransitionOptions) => void)): Function;

  abstract setPageTitle(fun: ((transitionTo: StateObject) => void)): void;

  abstract setChatInit?(fun: ((transitionTo: StateDeclaration) => void)): void;

  abstract setGlobalNotificationBanner?(fun: ((to: StateDeclaration) => void)): void;

  abstract setDataAnalyticsHooks?(initData: DataAnalyticsInitialData): Observable<DataAnalyticsEvent>;
}
